import { useEffect } from 'react';

export function getUnansweredQuestions(questions, questionsAnswers) {
	const unanswered = questions?.filter((question) => {
		if (question.required === 1 || question.required === '1') {
			const answers = questionsAnswers[question.short_name];
			return !answers || answers.length === 0;
		}
		return false;
	});
	return unanswered;
}

export function useFocusOnFirstUnansweredQuestion(unansweredQuestions, questions, questionRefs) {
	useEffect(() => {
		if (unansweredQuestions.length > 0) {
			// Get the order of questions as they appear on the page
			const questionOrder = questions?.map((q) => q.short_name) || [];

			// Find the first unanswered question based on visual order
			const firstUnansweredQuestion = questionOrder.find((questionName) =>
				unansweredQuestions.find((uq) => uq.short_name === questionName)
			);

			if (firstUnansweredQuestion && questionRefs.current[firstUnansweredQuestion]) {
				setTimeout(() => {
					questionRefs.current[firstUnansweredQuestion]?.focus();
				}, 100);
			}
		}
	}, [unansweredQuestions, questions, questionRefs]);
}
